import {createFileRoute} from '@tanstack/react-router';
import {PaymentLoadingPage} from 'features/shared/payment/PaymentLoadingPage';

export const Route = createFileRoute('/_protected/bill-payment/')({
  component: PaymentLoadingPage,
});
